export default  [
    93,
    3,
    183,
    273,
    363,
    453,
    543,
    633,
    723,
    813,
    903,
    993,
    1083,
    1173,
    1263,
    1353,
    1443,
    1533,
    1623,
    1713,
    1803,
    1893,
    1983,
    2073,
    2163,
    2253,
    2343,
    2433,
    2523,
    2613,
    2703,
    2973,
    3063,
    3153,
    3243,
    2793,
    2883,
    3427,
    3337,
    3517,
    3247,
    3157,
    3067,
    2977,
    2887,
    2797,
    2707,
    2617,
    2527,
    2437,
    2347,
    2257,
    2167,
    2077,
    1987,
    1897,
    1807,
    1717,
    1627,
    1537,
    1447,
    1357,
    1267,
    1177,
    1087,
    997,
    907,
    817,
    727,
    637,
    547,
    457,
    367,
    277,
    101,
    11,
    191,
    281,
    371,
    461,
    551,
    641,
    731,
    821,
    911,
    1001,
    1091,
    1181,
    1271,
    1361,
    1451,
    1541,
    1631,
    1721,
    1811,
    1901,
    1991,
    2081,
    2171,
    2261,
    2351,
    2441,
    2531,
    2621,
    2801,
    2891,
    2981,
    3071,
    3161,
    3251,
    2711,
    3435,
    3345,
    3255,
    3165,
    3525,
    3075,
    2985,
    2895,
    2805,
    2715,
    2625,
    2535,
    2445,
    2355,
    2265,
    2175,
    2085,
    1995,
    1905,
    1815,
    1725,
    1635,
    1545,
    1455,
    1365,
    1275,
    1185,
    1095,
    1005,
    915,
    825,
    735,
    645,
    555,
    465,
    375,
    285,
    109,
    19,
    199,
    289,
    379,
    469,
    559,
    649,
    739,
    829,
    919,
    1009,
    1099,
    1189,
    1279,
    1369,
    1459,
    1549,
    1639,
    1729,
    1819,
    1909,
    1999,
    2089,
    2179,
    2269,
    2359,
    2449,
    2539,
    2629,
    2719,
    2809,
    2899,
    2989,
    3079,
    3169,
    3259,
    3533,
    3443,
    3353,
    3263,
    3173,
    3083,
    2993,
    2903,
    2813,
    2723,
    2633,
    2543,
    2453,
    2363,
    2273,
    2183,
    2093,
    2003,
    1913,
    1823,
    1733,
    1643,
    1553,
    1463,
    1373,
    1283,
    1193,
    1103,
    1013,
    923,
    833,
    743,
    653,
    563,
    473,
    383,
    293,
    117,
    207,
    297,
    387,
    477,
    27,
    657,
    747,
    837,
    927,
    1017,
    567,
    1287,
    1197,
    1107,
    1377,
    1467,
    1557,
    1647,
    1737,
    1827,
    1917,
    2007,
    2097,
    2187,
    2277,
    2367,
    2457,
    2637,
    2547,
    2727,
    2817,
    2907,
    2997,
    3087,
    3177,
    3267,
    3541,
    3451,
    3361,
    3271,
    3181,
    3091,
    3001,
    2911,
    2821,
    2731,
    2641,
    2551,
    2461,
    2371,
    2281,
    2191,
    2101,
    2011,
    1921,
    1831,
    1741,
    1651,
    1561,
    1471,
    1381,
    1291,
    1201,
    1111,
    1021,
    931,
    841,
    751,
    661,
    571,
    481,
    391,
    301,
    35,
    125,
    215,
    305,
    395,
    485,
    575,
    665,
    755,
    845,
    935,
    1025,
    1115,
    1205,
    1295,
    1385,
    1475,
    1565,
    1655,
    1745,
    1835,
    1925,
    2015,
    2105,
    2195,
    2285,
    2375,
    2465,
    2555,
    2645,
    2735,
    2825,
    2915,
    3005,
    3095,
    3185,
    3275,
    3459,
    3369,
    3549,
    3279,
    3189,
    3099,
    3009,
    2919,
    2829,
    2739,
    2649,
    2559,
    2469,
    2379,
    2289,
    2199,
    2109,
    2019,
    1929,
    1839,
    1749,
    1659,
    1569,
    1479,
    1389,
    1299,
    1209,
    1119,
    1029,
    939,
    849,
    759,
    669,
    579,
    489,
    399,
    309,
    43,
    133,
    223,
    313,
    403,
    493,
    583,
    673,
    763,
    943,
    1123,
    1303,
    1483,
    1573,
    1663,
    1753,
    1843,
    1933,
    2023,
    2113,
    2203,
    2743,
    2653,
    2563,
    2473,
    2383,
    2293,
    2833,
    2923,
    3013,
    3103,
    3193,
    3283,
    853,
    1033,
    1213,
    1393,
    317,
    407,
    497,
    587,
    677,
    767,
    857,
    947,
    1037,
    1127,
    1217,
    1307,
    1397,
    1487,
    1577,
    1667,
    1757,
    1847,
    1937,
    2027,
    2117,
    2207,
    2297,
    2387,
    2477,
    2567,
    2657,
    2747,
    2837,
    2927,
    3017,
    3107,
    3197,
    3287,
    3377,
    3467,
    3557,
    51,
    141,
    231,
    321,
    411,
    501,
    591,
    681,
    771,
    861,
    951,
    1041,
    1131,
    1221,
    1311,
    1401,
    1491,
    1581,
    1671,
    1761,
    1851,
    1941,
    2031,
    2121,
    2211,
    2301,
    2391,
    2481,
    2571,
    2661,
    2751,
    2841,
    2931,
    3021,
    3111,
    3201,
    3291,
    3475,
    3385,
    3295,
    3205,
    3115,
    3025,
    2935,
    2845,
    2755,
    2665,
    2575,
    2485,
    2395,
    2305,
    2215,
    2125,
    2035,
    1945,
    1855,
    1765,
    1675,
    1585,
    1495,
    1405,
    1315,
    1225,
    1135,
    1045,
    955,
    865,
    775,
    685,
    595,
    505,
    415,
    325,
    3565,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
    337,
    338,
    339,
    340,
    341,
    342,
    344,
    345,
    346,
    343,
    348,
    349,
    350,
    351,
    352,
    353,
    354,
    355,
    347,
    356,
    357,
    447,
    537,
    627,
    717,
    807,
    897,
    987,
    1077,
    1167,
    1257,
    1347,
    1437,
    1527,
    1617,
    1707,
    1797,
    1887,
    1977,
    2067,
    2157,
    2247,
    2337,
    2427,
    2517,
    2607,
    2697,
    2787,
    2877,
    2967,
    3057,
    3147,
    3237,
    3327,
    3417,
    3504,
    3414,
    3324,
    3234,
    3144,
    3054,
    2964,
    2874,
    2784,
    2694,
    2604,
    2514,
    2424,
    2334,
    2244,
    2154,
    2064,
    1974,
    1884,
    1794,
    1704,
    1614,
    1524,
    1434,
    1344,
    1254,
    1164,
    1074,
    984,
    894,
    714,
    804,
    3594,
    712,
    711,
    710,
    713,
    779,
    869,
    959,
    1049,
    1139,
    1229,
    1319,
    1409,
    1499,
    690,
    691,
    692,
    693,
    694,
    695,
    696,
    697,
    698,
    699,
    700,
    701,
    702,
    703,
    704,
    705,
    706,
    707,
    708,
    709,
    689,
    1679,
    1769,
    1859,
    1949,
    2039,
    2129,
    2219,
    2309,
    2399,
    2489,
    2579,
    2669,
    2759,
    2849,
    2939,
    3029,
    3119,
    3209,
    3299,
    3389,
    1589,
    3390,
    3391,
    3392,
    3393,
    3394,
    3395,
    3396,
    3397,
    3398,
    3399,
    3400,
    3401,
    3402,
    3403,
    3404,
    3405,
    3406,
    3407,
    3408,
    3409,
    3410,
    3411,
    1501,
    1502,
    1682,
    1772,
    1500,
    1862,
    1952,
    2042,
    2132,
    2222,
    2312,
    2313,
    2314,
    2315,
    2316,
    2493,
    2494,
    2495,
    2496,
    2497,
    2498,
    2499,
    2500,
    2501,
    2502,
    2587,
    2947,
    2857,
    2767,
    2677,
    2761,
    2763,
    2764,
    2765,
    2760,
    2582,
    2672,
    2492,
    2762,
    2854,
    2944,
    3034,
    3124,
    3214,
    3123,
    3122,
    3121,
    3036,
    3037,
    3038,
    3039,
    3040,
    3041,
    3042,
    3043,
    2951,
    2681,
    2861,
    2771,
    3231,
    3051,
    2961,
    2871,
    2781,
    3141,
    2872,
    3050,
    3049,
    3048,
    3047,
    3046,
    2956,
    2596,
    2686,
    2776,
    2866,
    2598,
    2599,
    2600,
    2601,
    2602,
    2603,
    2510,
    1880,
    1790,
    1700,
    1610,
    1520,
    1430,
    1340,
    1250,
    1070,
    980,
    1149,
    1150,
    1151,
    1152,
    1153,
    1154,
    1155,
    1156,
    1157,
    1158,
    1159,
    1160,
    968,
    1058,
    1148,
    1238,
    1328,
    1418,
    1508,
    1598,
    1688,
    1778,
    1868,
    1684,
    1683,
    1592,
    1685,
    1686,
    1057,
    1056,
    1054,
    1053,
    1052,
    1051,
    964,
    874,
    784,
    1142,
    1232,
    1322,
    1323,
    1324,
    1325,
    1326,
    1504,
    1414,
    1505,
    1509,
    1510,
    1511,
    1512,
    1513,
    1514,
    1515,
    1516,
    1517,
    1518,
    1693,
    1783,
    1873,
    1963,
    1603,
    1331,
    1421,
    1341,
    1342,
    975,
    885,
    887,
    888,
    886,
    884,
    883,
    882,
    881,
    880,
    970,
    1065,
    892,
    982,
    1072,
    1073,
    1702,
    1792,
    1882,
    1972,
    2062,
    2152,
    2242,
    1703,
    1960,
    2050,
    2140,
    2230,
    2320,
    2410,
    1869,
    1870,
    2041,
    1860,
    2310,
    2581,
    1681,
    1877,
    1967,
    2057,
    2237,
    2143,
    2148,
    2145,
    2144,
    2146,
    2147,
    2327,
    2417,
    2414,
    2415,
    3129,
    3219,
    3222,
    3312,
    3044,
    3134,
    3224,
    1955,
    1956,
    2046,
    2136,
    2137,
    1954,
    2134,
    2135,
    2138,
    2318,
    2319,
    2228,
    2150,
    2240,
    2330,
    2329,
    2233,
    1425,
    1337,
    1247,
    1335,
    1784,
    1785
]